import { render, staticRenderFns } from "./NavigationListItem.vue?vue&type=template&id=0477b56e&scoped=true&"
import script from "./NavigationListItem.vue?vue&type=script&lang=js&"
export * from "./NavigationListItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationListItem.vue?vue&type=style&index=0&id=0477b56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0477b56e",
  null
  
)

export default component.exports